// removed by extract-text-webpack-plugin
module.exports = {"input":"input-2n2B_","input-start":"input-start-2WZ02","input-end":"input-end-3SmNz","label":"label-17LRA","label-search":"label-search-1avJN","dash":"dash-23tYa","prefix":"prefix-Ttzxn","prefix-search":"prefix-search-2WZ5Y"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/train-in-way/style.scss
 ** module id = 67
 ** module chunks = 0
 **/